import { defineStore } from "pinia";

const useStore = defineStore("store", {
  state() {
    return {
      token: "",
    };
  },
});

export function storeInstaller(app) {
  app.provide("useStore", useStore);
  app.config.globalProperties.useStore = useStore;
}
